<template>
  <jade-box
    :title="$t('refusalCodesTitle')"
    hasPadding
    class="flex-1"
  >
    <template>
      <dash-card-content-fallback :hasData="hasData">
        <dash-progress-bar
          v-for="(item, index) in refuseReasons"
          :key="item.key + '' + index"
          :value="item.percentage"
          :color="item.color"
        >
          <refusal-codes-icons
            :data-icon="item.leftIcon"
            :tooltip-id="'acquirer_info-tippy-left' + item.key"
          />

          <jade-text>{{ $t(item.name) }}</jade-text>

          <refusal-codes-icons
            :data-icon="item.rightIcon"
            :tooltip-id="'acquirer_info-tippy-right' + item.key"
          />
        </dash-progress-bar>
      </dash-card-content-fallback>
    </template>
  </jade-box>
</template>

<script>
import { JadeBox, JadeText } from '@jade'

import DashProgressBar from '../components/DashProgressBar/index.vue'
import DashCardContentFallback from '../components/DashCardContentFallback/index.vue'

import DashProgressManager from '../dash-progress.manager'

import RefusalCodesManager from './refusal-codes.manager'
import RefusalCodesIcons from './RefuseCodeTooltip.vue'

export default {
  name: 'RefusalCodes',

  components: {
    JadeBox,
    JadeText,
    DashProgressBar,
    DashCardContentFallback,

    RefusalCodesIcons
  },

  props: {
    data: Array
  },

  computed: {
    hasData () {
      return this.refuseReasons.length > 0
    },
    refuseReasons () {
      return new RefusalCodesManager(
        this.data, //
        new DashProgressManager(
          this.data, //
          RefusalCodesManager.totalQuantity(this.data)
        )
      ).get()
    }
  }
}
</script>

<style scoped>
.card-content__refuse-codes {
  overflow-y: auto;
}
</style>

<i18n>
  {
    "pt-BR": {
      "refusalCodesTitle": "Motivos de recusa por adquirente",
      "refusalCodesDescription": "5 principais códigos retornados pelas adquirentes em cobranças não autorizadas.",
      "refusalCodes": {
        "simulator": "Simulator"
      }
    },
    "en-US": {
      "refusalCodesTitle": "Major refusal codes by acquirer",
      "refusalCodesDescription": "5 main acquirers return code on unauthorized charges.",
      "refusalCodes": {
        "simulator": "Simulator"
      }
    }
  }
  </i18n>
